var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifies),function(notify){return _c('div',{key:notify.id,staticClass:"n-notify",on:{"click":function($event){return _vm.$app.ui.closeNotify(notify.id)}}},[_c('div',{staticClass:"body-place"},[_c('div',{staticClass:"body",class:notify.color},[_vm._v(" "+_vm._s(notify.message)+" ")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }